/**
 * `FileReader` devolve `data:<tipo>;base64,XXX` — só o depois da vírgula
 * interessa à API, que recebe o conteúdo em base64 puro.
 *
 * Mora aqui, e não dentro de um componente, porque três telas mandam arquivo
 * para o mesmo endpoint: o detalhe do e-mail, o anexo rápido da linha do
 * cronograma e a importação de modelo do Word.
 */
export async function lerComoBase64(arquivo: File): Promise<string> {
  const leitor = new FileReader();
  return new Promise((resolver, rejeitar) => {
    leitor.onload = () => {
      const resultado = String(leitor.result);
      resolver(resultado.slice(resultado.indexOf(',') + 1));
    };
    leitor.onerror = () => rejeitar(new Error('Não foi possível ler o arquivo.'));
    leitor.readAsDataURL(arquivo);
  });
}
